const config = require('../../config/runtime_config.js')

module.exports = [
	{
		path: '/',
		name: 'Home',
		component: () => import(`@/pages/home/home.vue`),
		meta: {
			label: 'Accueil',
			icon: 'home',
			description: '',
			section: null
		}
	},

	{
		path: '/login',
		name: 'login',
		component: () => import(`@/pages/login/login.vue`),
		meta: {
			label: 'login',
			icon: 'person',
			description: '',
			section: null
		}
	},

	{
		path: '/complete/tpauth-oidc/',
		name: 'Complete TPauth OIDC Callback',
		component: () => import(`@/pages/login/tpauth_callback.vue`),
		meta: {
			label: 'Complete TPauth OIDC Callback',
			icon: 'person',
			description: '',
			section: null
		}
	},

	{
		path: '/robots.txt',
		redirect: '/',
		meta: {
			section: null
		}
	},

	{
		path: '/asset/:id',
		name: 'Asset',
		component: () => import('@/pages/assets/asset.vue'),
		meta: {
			label: 'Asset',
			icon: 'subscriptions',
			description: `Page de visualisation d'un asset`,
			disabled: true
		}
	},

	{
		path: '/maestro',
		name: 'Maestro',
		component: () => import('@/components/section_page.vue'),
		meta: {
			label: 'Maestro',
			icon: 'queue_music',
			description: '',
			section: 'maestro',
			has_home_link: true
		},
		children: require(`@/router/routes_maestro`)
	},

	{
		path: '/vantage',
		name: 'Vantage',
		redirect: { name: 'Vantage Jobs' },
		component: () => import('@/components/section_page.vue'),
		meta: {
			label: 'Vantage',
			icon: 'device_hub',
			description: '',
			section: 'tools',
			has_home_link: true
		},
		children: require(`@/router/routes_vantage`)
	},

	{
		path: '/explorer',
		name: 'Explorer',
		component: () => import('@/components/section_page.vue'),
		meta: {
			label: 'Explorateur',
			icon: 'folder',
			description: '',
			section: 'tools'
		},
		children: require(`@/router/routes_explorer`)
	},

	{
		path: '/packages',
		name: 'Packages',
		component: () => import('@/components/section_page.vue'),
		meta: {
			label: 'Packages',
			icon: 'tv',
			description: '',
			section: 'tools'
		},
		children: require(`@/router/routes_packages`)
	},

	{
		path: '/tools',
		name: 'Tools',
		component: () => import('@/components/section_page.vue'),
		meta: {
			label: 'Outils',
			icon: 'build',
			description: '',
			section: 'tools'
		},
		children: require(`@/router/routes_tools`)
	},

	{
		path: '/test',
		name: 'Test',
		component: () => import('@/components/section_page.vue'),
		meta: {
			label: 'Tests',
			icon: 'code',
			description: '',
			section: config._$ppt9qr !== 'production' ? 'tools' : null
		},
		children: require(`@/router/routes_tests`)
	},

	{
		path: '/changelog',
		name: 'Changelogs',
		component: () => import('@/pages/about/changelogs.vue'),
		meta: {
			label: 'Changelogs',
			icon: 'info',
			description: '',
			section: null,
			about_btn: true,
			about_btn_color: 'info accent-2'
		}
	},

	{
		path: '/changelog/:id/',
		name: 'Changelog',
		component: () => import('@/pages/about/changelogs.vue'),
		meta: {
			label: 'Changelog',
			icon: 'code',
			description: '',
			section: null
		}
	},

	{
		path: '/support',
		name: 'Support',
		component: () => import('@/pages/about/support.vue'),
		meta: {
			label: 'Support',
			icon: 'contact_support',
			description: 'Displays all support tickets',
			section: null,
			about_btn: true,
			about_btn_color: 'green accent-3'
		},
		query: {
			status: 0
		}
	},

	{
		path: '/support/:ref/',
		name: 'Ticket',
		component: () => import('@/pages/about/ticket.vue'),
		meta: {
			label: 'Ticket',
			icon: 'code',
			description: 'Displays support ticket information',
			section: null
		}
	},

	{
		path: '/gravitools',
		name: 'Gravitools',
		component: () => import('@/pages/about/admin.vue'),
		meta: {
			label: 'Gravitools',
			icon: 'admin_panel_settings',
			description: 'Displays all admin features',
			section: null,
			admin_btn: true,
			admin_btn_color: 'primary'
		}
	},

	{
		path: '/maestro_search',
		name: 'Maestro search',
		component: () => import('@/pages/maestro/jd/jd_finder.vue'),
		meta: {
			label: 'Maestro search',
			icon: 'admin_panel_settings',
			description: 'module to find maestro JD',
			section: null,
			admin_btn_color: 'primary'
		}
	},

	{
		path: '/mapping',
		name: 'Mappings',
		component: () => import('@/pages/about/mappings.vue'),
		meta: {
			label: 'Mappings',
			icon: 'data_object',
			description: 'Displays mappings',
			section: null,
			about_btn: true,
			about_btn_color: 'yellow'
		}
	},

	{
		path: '/mapping/:slug',
		name: 'Mapping',
		component: () => import('@/pages/about/mappings.vue'),
		meta: {
			label: 'Mappings',
			icon: 'data_object',
			description: 'Displays mappings',
			section: null
		}
	},

	{
		path: '/piman/:material_id/',
		name: 'piman',
		component: () => import('@/pages/piman/piman.vue'),
		meta: {
			label: 'Piman',
			icon: 'code',
			description: ''
		}
	},

	{
		path: '*',
		name: '404',
		component: () => import('@/pages/errors/NotFound.vue'),
		meta: {
			label: '404',
			icon: 'error',
			section: null
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes.js